module.exports = __webpack_public_path__ + "static/media/top.c11d8c48.webp";